module.exports = __webpack_public_path__ + "static/media/feature-1.2d4f0ed8.png";


//////////////////
// WEBPACK FOOTER
// ./src/landing/images/feature-1.png
// module id = 340
// module chunks = 0